export default __webpack_public_path__ + "static/media/MarkW07-Bold.cdbaba6e.woff2";